import { ReactElement } from 'react'
import EditIcon from '@mui/icons-material/EditOutlined'
import {
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material'
import type { OrganisationDTO } from '@api/fastAPI.schemas'
import { formatDateTime } from '../../utils'

interface Props {
  organisations: OrganisationDTO[]
  onEdit: (organisation: OrganisationDTO) => void
}

const OrganisationList = ({ organisations, onEdit }: Props): ReactElement => {
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="organisation table" data-cy="organisation-list">
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>GUID</TableCell>
            <TableCell>Erstellt</TableCell>
            <TableCell align="right">Anzahl Benutzer</TableCell>
            <TableCell align="right" />
          </TableRow>
        </TableHead>
        <TableBody>
          {organisations.length === 0 && (
            <TableRow>
              <TableCell colSpan={5} align="center" sx={{ color: 'text.secondary' }}>
                Keine Einträge
              </TableCell>
            </TableRow>
          )}
          {organisations.map(organisation => (
            <TableRow key={organisation.guid}>
              <TableCell>{organisation.name || '—'}</TableCell>
              <TableCell>{organisation.guid}</TableCell>
              <TableCell>{formatDateTime(organisation.created_at)}</TableCell>
              <TableCell align="right">{organisation.user_count}</TableCell>
              <TableCell align="right">
                <IconButton
                  size="small"
                  onClick={() => onEdit(organisation)}
                  data-cy="btn-edit-organisation"
                >
                  <EditIcon fontSize="small" />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default OrganisationList
